import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_22: FaireProductEntity = {
  token: "legacy_prod_abbott-22",
  type: "product",
  name: "Merino 101",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d24492a0cc618a5ce5ed4be1341df37c22b82c6b36c7507df0df2a806f57c6d9.jpeg",
  priceDollars: 26,
  subcategory: "Art & Prints",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_wall-decor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
